/**
 * Partner configuration for the application.
 * Centralizes partner-related settings and IDs.
 */

export const PARTNER_CONFIG = {
  // Primary partner ID for the application - from environment variable with fallback
  PARTNER_ID: import.meta.env.VITE_PARTNER_ID || 'cigna',

  // Partner-specific settings
  SETTINGS: {
    // Token cache duration in milliseconds (5 minutes)
    TOKEN_CACHE_DURATION: 5 * 60 * 1000,

    // Number of retry attempts for token requests
    TOKEN_RETRY_ATTEMPTS: 2,
  },
} as const;

/**
 * Partner token configuration for different content types.
 */
export const PARTNER_TOKEN_CONFIG = {
  // Patterns that require partner tokens
  SECURED_PATTERNS: [
    {
      path: '/secured/',
      contentType: 'application/pdf' as const,
      useRootUrl: false,
      partnerId: PARTNER_CONFIG.PARTNER_ID,
    },
  ],

  // Patterns that use regular tokens
  REGULAR_PATTERNS: [
    {
      path: '/sso/vendors/',
      contentType: 'text/html' as const,
      useRootUrl: true,
    },
  ],
} as const;
